<template>
  <div class="select-department">
    <div class="select-department-header">
      <x-input-search placeholder="搜索部门" @search="handleSearch"></x-input-search>
    </div>
    <div class="select-department-body">
      <keep-alive>
        <tree-panel
          v-if="mode === 'TREE'"
          ref="treePanel"
          :selectType="selectType"
          :canSelectAll.sync="canSelectAll"
          @select="handleSelect"
        ></tree-panel>
      </keep-alive>
      <list-panel
        v-if="mode === 'LIST'"
        ref="listPanel"
        :keyWord="keyWord"
        :isTile.sync="isTile"
        :selectType="selectType"
        :canSelectAll.sync="canSelectAll"
        @select="handleSelect"
      ></list-panel>
    </div>
    <div class="select-department-footer">
      <div v-if="selectType === 'MULTI'" class="footer--icon" @click="handleSelectAll">
        <x-svg-icon v-if="canSelectAll" name="x-lib-all-checkbox"></x-svg-icon>
        <x-svg-icon v-else name="x-lib-all-checkbox-active"></x-svg-icon>
      </div>
      <div class="footer--info text-ellipsis">
        <span class="footer--help">{{ help }}</span>
      </div>
      <div class="footer--btn">
        <cube-button primary @click="handleConfirm">
          确定
        </cube-button>
      </div>
    </div>
  </div>
</template>

<script>
import TreePanel from './tree-panel/tree-panel'
import ListPanel from './list-panel/list-panel'
import {
  SET_COMP_VALUE
} from '@/store/comp-router.store.js'
import {
  SET_SELECTED_ARRAY,
  PUSH_SELECTED_ARRAY,
  POP_SELECTED_ARRAY,
  RESET_DEPARTMENT_STORE,
  REMOVE_SELECTED_ARRAY,
  POP_NAV_MENU
} from '@/store/department.store.js'
import {
  mapState,
  mapMutations
} from 'vuex'

export default {
  components: {
    TreePanel,
    ListPanel
  },
  data() {
    return {
      compPayloadKey: this.$route.query.key,
      mode: 'TREE', // LIST | TREE
      canSelectAll: true,
      keyWord: '',
      isTile: false // 若为true则使用过滤接口,且均使用list方式展现
    }
  },
  computed: {
    ...mapState({
      compPayload: state => state.compRouterModule.compPayload,
      navMenu: state => state.departmentModule.navMenu,
      selectedArray: state => state.departmentModule.selectedArray
    }),
    selectType() {
      return this.compPayload[this.compPayloadKey].widgetConfig.chooseType
    },
    help() {
      return this.selectType === 'SINGLE'
        ? `单选，已选择「${this.selectedArray[0] ? this.selectedArray[0].name : ''}」`
        : `多选，已选择${this.selectedArray.length}条记录 ${this.selectedArray.length}/30`
    }
  },
  created() {
    if (this.compPayload[this.compPayloadKey].value instanceof Array) {
      this.setSelectedArray(this.$lodash.cloneDeep(this.compPayload[this.compPayloadKey].value))
    }
    let widget = this.$lodash.cloneDeep(this.compPayload[this.compPayloadKey].widgetConfig)
    this.isTile = (function () {
      if (
        widget.selectedDataSourceList === undefined ||
        widget.selectedDataSourceList.length === 0
      ) {
        // 如果没有数据来源或数据来源为空则使用老接口
        return false
      } else {
        if (widget.selectedDataSourceList[0].type === 'departmentSelectAll') {
          // 如果来源为全部 且 不存在过滤条件则走老接口
          if (
            widget.filterConditionGroupList &&
            widget.filterConditionGroupList.length > 0
          ) {
            for (const item of widget.filterConditionGroupList) {
              if (item.selectorFilterConditionList && item.selectorFilterConditionList.length > 0) {
                return true
              }
            }
          }
          return false
        }
      }
      return true
    })()
    if (this.isTile) {
      this.mode = 'LIST'
    } else {
      this.mode = 'TREE'
    }
  },
  mounted() {
    window.addEventListener('popstate', this.goBack, false)
  },
  beforeDestroy() {
    window.removeEventListener('popstate', this.goBack, false)
    this.resetDepartmentStore()
  },
  methods: {
    ...mapMutations('compRouterModule', {
      setCompValue: SET_COMP_VALUE
    }),
    ...mapMutations('departmentModule', {
      setSelectedArray: SET_SELECTED_ARRAY,
      pushSelectedArray: PUSH_SELECTED_ARRAY,
      popSelectedArray: POP_SELECTED_ARRAY,
      removeSelectedArray: REMOVE_SELECTED_ARRAY,
      resetDepartmentStore: RESET_DEPARTMENT_STORE,
      popNavMenu: POP_NAV_MENU
    }),
    goBack() {
      this.popNavMenu()
    },
    handleSearch(value) {
      this.keyWord = value
      if (this.keyWord) {
        this.mode = 'LIST'
      } else {
        if (this.isTile) {
          this.mode = 'LIST'
        } else {
          this.mode = 'TREE'
        }
      }
    },
    handleSelectAll() {
      this.canSelectAll = !this.canSelectAll
      if (this.mode === 'LIST') {
        this.$refs.listPanel && this.$refs.listPanel.handleSelectAll(!this.canSelectAll)
      } else if (this.mode === 'TREE') {
        this.$refs.treePanel && this.$refs.treePanel.handleSelectAll(!this.canSelectAll)
      }
    },
    handleSelect(department) {
      if (department.checked) {
        if (this.selectedArray.length < 30) {
          if (this.selectType === 'SINGLE') {
            let o = this.popSelectedArray()
            if (o) o.checked = false
          }
          this.pushSelectedArray(department)
        } else {
          department.checked = false
        }
      } else {
        this.removeSelectedArray(department)
      }
    },
    handleConfirm() {
      this.setCompValue({
        key: this.$route.query.key,
        value: this.$lodash.cloneDeep(this.selectedArray)
      })
      this.$router.go(-this.navMenu.length)
    }
  }
}
</script>

<style lang="scss">
.select-department {
  width: 100vw;
  height: 100vh;
  background-color: $--app-body-bgColor;
  overflow: hidden;
  .select-department-body {
    height: calc(100vh - 7.42rem);
    overflow-y: auto;
  }
  .select-department-footer {
    position: fixed;
    bottom: 0;
    width: 100vw;
    display: flex;
    align-items: center;
    height: 3.71rem;
    padding: 0 1.14rem;
    box-sizing: border-box;
    background-color: $--app-box-bgColor;
    .footer--icon {
      margin-right: 0.857rem;
      color: $--app-notice-font-color;
      .svg-x-lib-all-checkbox-active {
        color: $--app-primary-color;
      }
    }
    .footer--info {
      flex: 1;
      .footer--help {
        color: $--app-notice-font-color;
      }
    }
    .footer--btn {
      flex: 0 0 4.64rem;
    }
  }
}
</style>
